import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { IPbisSummaryResult } from 'libs/domain';
import { ColumnInfo, TemplateColumnKeys, BehaviorReportColumns } from 'libs/shared';

import { ReportDatasourceService } from '@app/src/app/components/manager-report/services/report-datasource.service';

import { BHTypeHistoryInfo, BHTypeSummaryInfo } from '../constants';
import { BmReportsService } from './bm-reports.service';

@Injectable()
export class BmReportsBehaviorsDatasourceService extends ReportDatasourceService<IPbisSummaryResult> {
  historyInfo = BHTypeHistoryInfo;
  summaryInfo = BHTypeSummaryInfo;

  constructor(_router: Router, private _pbisReportsService: BmReportsService) {
    super(_router, _pbisReportsService, BmReportsBehaviorsDatasourceService.name);
    const displayCol: ColumnInfo[] = [
      {
        key: TemplateColumnKeys.SUMMARY,
        header: 'Summary',
        columnClasses: ['w-16'],
      },
      {
        key: TemplateColumnKeys.HISTORY,
        header: 'History',
        columnClasses: ['w-16'],
      },
    ];
    super.setDisplayColumns(BehaviorReportColumns.TYPES, displayCol);
  }

  async fetch(offset: number, limit: number) {
    return await this._pbisReportsService.getBehaviorTypes(offset, limit, this._currentSort);
  }
}
